import { UseCaseInteractor } from '../../../kernel/use-case'
import { ItemRepository } from '../domain/item.repository'
import { JobItem } from '../domain/items'

export const getItemsByJobUseCase: UseCaseInteractor<[itemRepository: ItemRepository], [jobId: string], JobItem[]> =
  (itemRepository: ItemRepository) =>
  async (jobId: string): Promise<JobItem[]> => {
    return itemRepository.getItemsByJob(jobId)
  }
